var s = /* @__PURE__ */ ((r) => (r.PublicUserId = "sio_u_public", r.BrowserSessionActiveId = "sio_browser_session_active_id", r))(s || {});
export {
  s as CookiesEnum
};
